// Google Analytics 4 Event Tracking Utility

/**
 * Track custom events in Google Analytics 4
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Additional parameters for the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
    // Event tracked successfully
  }
};

/**
 * Track page views
 * @param {string} pageTitle - Title of the page
 * @param {string} pagePath - Path of the page
 */
export const trackPageView = (pageTitle, pagePath) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_title: pageTitle,
      page_path: pagePath,
      page_location: window.location.href,
    });
  }
};

/**
 * Track contact form submissions
 * @param {string} formType - Type of form (e.g., 'contact', 'newsletter')
 * @param {object} formData - Form data (without sensitive info)
 */
export const trackFormSubmission = (formType, formData = {}) => {
  trackEvent('form_submission', {
    form_type: formType,
    form_name: formData.name || 'unknown',
    ...formData,
  });
};

/**
 * Track WhatsApp button clicks
 * @param {string} location - Where the button was clicked from
 */
export const trackWhatsAppClick = (location) => {
  trackEvent('whatsapp_click', {
    button_location: location,
    click_type: 'contact',
  });
};

/**
 * Track consultation button clicks
 * @param {string} location - Where the button was clicked from (e.g., 'navbar', 'hero', 'cta')
 */
export const trackConsultationClick = (location) => {
  trackEvent('consultation_click', {
    button_location: location,
    action_type: 'lead_generation',
  });
};

/**
 * Track blog post views
 * @param {string} postTitle - Title of the blog post
 * @param {string} postCategory - Category of the blog post
 */
export const trackBlogView = (postTitle, postCategory) => {
  trackEvent('blog_view', {
    post_title: postTitle,
    post_category: postCategory,
    content_type: 'blog',
  });
};

/**
 * Track newsletter subscriptions
 * @param {string} email - Email address (hashed or anonymized)
 */
export const trackNewsletterSignup = () => {
  trackEvent('newsletter_signup', {
    method: 'blog_page',
  });
};

/**
 * Track social share clicks
 * @param {string} platform - Social media platform
 * @param {string} contentType - Type of content being shared
 */
export const trackSocialShare = (platform, contentType) => {
  trackEvent('share', {
    method: platform,
    content_type: contentType,
  });
};

export default {
  trackEvent,
  trackPageView,
  trackFormSubmission,
  trackWhatsAppClick,
  trackConsultationClick,
  trackBlogView,
  trackNewsletterSignup,
  trackSocialShare,
};
